<mat-nav-list>
  <ng-container *ngFor="let item of sidebarNavigation">
    <mat-list-item [routerLink]="[item.routeLink]" (click)="actionClicked(item.routeLink)">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="menu-item">
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.routeName | translate }}</span>
      </div>
    </mat-list-item>
  </ng-container>
</mat-nav-list>
